import { Component } from '@angular/core';
import { App, NavController, NavParams } from 'ionic-angular';
import { NewsDetailsModel } from '../../../providers/news/news';
import { EventProvider } from '../../../providers/event/event';
import { LoaderProvider } from '../../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { EventTabsPage } from '../../event/details/event-tabs/event-tabs';

/**
 * Generated class for the NotificationDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-notification-details',
  templateUrl: 'notification-details.html',
})
export class NotificationDetailsPage {

  news: NewsDetailsModel;
  constructor(
  	public navCtrl: NavController,
    public navParams: NavParams,
    public eventService:EventProvider,
    private loadingCtrl:LoaderProvider,
    private translate:TranslateService,
    private app:App
  ) {
    this.news = navParams.data.news;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NotificationDetailsPage');
  }

  openEvent() {
    /*
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.eventService.getEventDetails(this.news.event.id).then((event) => {
      (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
    });

    */
  }

}



// WEBPACK FOOTER //
// /src/pages/notification/details/notification-details.ts